import { Dispatch, SetStateAction, useEffect, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ctxPluto } from '@/contexts/PlutoContext';
import { Popup } from '@/components/common/Popup';
import TargetSelectorOpenerButton from '@/components/common/TargetSelectorOpenerButton';
import { ctxUser } from '@/contexts/UserContext';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';

import { BottomSheet } from '@/components/common/BottomSheet';
import { HeaderNameAndIcons } from '@/components/common/HeaderNameAndIcons';
import TargetTrackingPanel from './TargetTrackingPanel';
import TrackingTargetSelector from './TrackingTargetSelector';
import { trackedTargetLimit } from '@/tmp/TargetService';
import { rethrowIfNotClientException } from '@/utilities/throwableUtils';

import '@/components/common/Icons.css';
import './TrackingPopup.css';
import Box from '@mui/material/Box';

// target selector popup gorgetheto body resze
function Body({
  trackingLimit,
  setShowTargetSelector,
}: {
  trackingLimit: number;
  setShowTargetSelector: Dispatch<SetStateAction<boolean>>;
}) {
  function InfiniteList() {
    return <TrackingTargetSelector trackingLimit={trackingLimit} setShowTargetSelector={setShowTargetSelector} />;
  }

  if (isPhoneOrHighScreen()) {
    return (
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <InfiniteList />
      </Box>
    );
  }

  return (
    <div className="tracking-body-target" data-qa-element-id="multi_element_selector_panel">
      <InfiniteList />
    </div>
  );
}

// popup, a kivalasztott target listat modositja
export default function TrackingPopup() {
  const ctx = useContext(ctxPluto);
  const userCtx = useContext(ctxUser);
  const { t } = useTranslation();
  const [trackingLimit, setTrackingLimit] = useState<number | undefined>(undefined);
  const [showTargetSelector, setShowTargetSelector] = useState(false);
  const [isVehicleSelected, setIsVehicleSelected] = useState(false);
  const target = ctx?.fullTargets?.find((t) => t.target.id === ctx?.popupTargetId);

  useEffect(() => {
    async function getTrackingLimit() {
      try {
        const response = await trackedTargetLimit();
        if (response.status === 200) {
          if (!response.data) {
            console.debug('tracked target limit is missing');
            setTrackingLimit(50); // FIXME put sane defaults into separate file
          } else {
            setTrackingLimit(response.data);
          }
        }
      } catch (error) {
        rethrowIfNotClientException(error);
      }
    }
    if (userCtx?.isToken()) {
      setTrackingLimit(1);
      return;
    }
    void getTrackingLimit();
  }, [userCtx]);

  useEffect(() => {
    ctx?.setMode('target'); // show selectedTargets on the map
  }, [ctx]);

  useEffect(() => {
    ctx?.setIsBottomSheetOpen(ctx?.popupTargetId !== undefined);

    return () => ctx?.setIsBottomSheetOpen(false);
  }, [ctx?.popupTargetId]);

  useEffect(() => {
    if (ctx?.fullTargets !== undefined) {
      setIsVehicleSelected(true);
    } else {
      setIsVehicleSelected(false);
    }
  }, [ctx?.fullTargets]);

  const body = useMemo(() => {
    if (!trackingLimit) return <></>;
    return <Body trackingLimit={trackingLimit} setShowTargetSelector={setShowTargetSelector} />;
  }, [trackingLimit]);

  async function onClose() {
    setShowTargetSelector(false);
    ctx?.setFocusedTarget(null);
  }

  // a header is scrollozodjon es a body is
  // akkor kellene a header max height ?
  return isPhoneOrHighScreen() ? (
    <>
      {!userCtx?.isToken() && (
        <TargetSelectorOpenerButton
          setOnClicked={setShowTargetSelector}
          targetSelected={!!target}
          isVehicleOrRouteSelected={isVehicleSelected}
          title={t('mainMenu.tracking')}
        />
      )}
      {showTargetSelector && (
        <Popup
          popupTitle={t('mainMenu.tracking')}
          header={undefined}
          body={body}
          footer={undefined}
          closePopup={onClose}
          isFullScr={true}
          leftText={true}
        />
      )}
      {ctx?.popupTargetId && target && (
        <BottomSheet
          header={
            <HeaderNameAndIcons
              target={target.target}
              onClose={() => ctx?.setPopupTargetId(undefined)}
              onReload={() => ctx?.setImmediateLoadTargetId(ctx?.popupTargetId)}
            />
          }
          setClosed={() => ctx.setIsBottomSheetOpen(false)}
          isBottomSheetUp={ctx.isBottomSheetOpen}
          setBottomSheetUp={ctx.setIsBottomSheetOpen}
        >
          <TargetTrackingPanel />
        </BottomSheet>
      )}
    </>
  ) : (
    <>
      <div className="tracking-panel">{body}</div>
    </>
  );
}
